module.exports = __webpack_public_path__ + "32056556be8d5a4f2da0880c4b97ca25.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/GC_BIERKIRCHE.jpg
// module id = 475
// module chunks = 0